import { MetaDecorator as SharedMetaDecorator } from '@rcw/ui';

const DOMAIN = `${process.env.REACT_APP_PUBLIC_URL}/`;

export default function MetaDecorator(props) {
  return <SharedMetaDecorator domain={DOMAIN} {...props} />;
}
